// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function markUrlAsTrusted(settings, url) {
  if (Belt_Option.isSome(Caml_option.undefined_to_opt(settings.webSrcSettings.find(function (ws) {
                  return ws.url === url;
                })))) {
    var newrecord = Caml_obj.obj_dup(settings);
    newrecord.webSrcSettings = settings.webSrcSettings.map(function (ws) {
          if (ws.url === url) {
            return {
                    alias: ws.alias,
                    url: ws.url,
                    trusted: true
                  };
          } else {
            return ws;
          }
        });
    return newrecord;
  }
  var newrecord$1 = Caml_obj.obj_dup(settings);
  newrecord$1.webSrcSettings = settings.webSrcSettings.concat([{
          alias: "",
          url: url,
          trusted: true
        }]);
  return newrecord$1;
}

function settingsGetTypeColors(settings) {
  return Belt_HashMapString.fromArray(settings.typeSettings.map(function (ts) {
                  return [
                          ts.typ,
                          ts.color
                        ];
                }));
}

exports.markUrlAsTrusted = markUrlAsTrusted;
exports.settingsGetTypeColors = settingsGetTypeColors;
/* No side effect */
